import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import EnterpriseIcon, { DataTableIcon, ChevronDownIcon } from '@enterprise-ui/icons';
import React__default, { useRef, useState } from 'react';
import FocusTrap from '../../../../utils/FocusTrap.js';
import Button from '../../../Button.js';
import Grid from '../../../Grid.js';
import Overlay from '../../../Overlay.js';
import ColumnManager from './ColumnManager.js';

var ColumnManagerToggle = function ColumnManagerToggle(_ref) {
  var _ref$location = _ref.location,
    location = _ref$location === void 0 ? 'left' : _ref$location,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    _ref$dataTestId = _ref.dataTestId,
    dataTestId = _ref$dataTestId === void 0 ? 'column_manager' : _ref$dataTestId,
    allowSorting = _ref.allowSorting,
    allowPinning = _ref.allowPinning;
  var buttonElementRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var handleShow = function handleShow() {
    setIsVisible(function (prev) {
      return !prev;
    });
  };
  var onRefuseHandler = function onRefuseHandler() {
    setIsVisible(false);
  };
  var props = {
    allowPinning: allowPinning,
    allowSorting: allowSorting,
    isVisible: isVisible,
    location: location,
    size: size
  };
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "".concat(dataTestId, "_toggle"),
    className: "C-ColumnManager__Toggle"
  }, /*#__PURE__*/React__default.createElement(FocusTrap, {
    as: "div",
    active: isVisible,
    returnFocusTo: buttonElementRef.current,
    onEscape: onRefuseHandler
  }, /*#__PURE__*/React__default.createElement(Button, {
    "data-testid": "".concat(dataTestId, "_button"),
    ref: buttonElementRef,
    type: "secondary",
    "aria-label": "".concat(isVisible ? 'close' : 'open', " column manager"),
    onClick: handleShow
  }, /*#__PURE__*/React__default.createElement(Grid.Container, {
    spacing: "dense"
  }, /*#__PURE__*/React__default.createElement(Grid.Item, null, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    size: "sm",
    icon: DataTableIcon
  })), /*#__PURE__*/React__default.createElement(Grid.Item, null, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    size: "sm",
    icon: ChevronDownIcon
  })))), /*#__PURE__*/React__default.createElement(ColumnManager, _extends({
    dataTestId: "".concat(dataTestId)
  }, props))), /*#__PURE__*/React__default.createElement(Overlay, {
    type: "transparent",
    onClick: onRefuseHandler,
    isVisible: isVisible
  }));
};

export { ColumnManagerToggle as default };
